import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { AppsRoundedIcon } from '../../../icons/AppsRoundedIcon';
import { BottomNavStyled, bottomNavPwaSx } from './style';
import { IconProjects } from '../../../icons/IconProjects';
import { IconSocialOrders } from '../../../icons/IconSocialOrders';
import { routesProfile } from '../../../consts';
import { IconUsers } from '../../../icons/IconUsers';
import { BottomNavMenu } from '../BottomNavMenu';
import { DynamicFeedRoundedIcon } from '../../../icons/DynamicFeedRoundedIcon';
import { COLORS } from '../../../styles/variables';

/** Наследуем цвет с `BottomNavigationAction` (тема: обычное / выбранное). */
const bottomNavIconSx = { color: COLORS.NICE_BLUE } as const;

type MobileBottomNavProps = {
  isPwa?: boolean
}

export const MobileBottomNav = ({ isPwa = false }: MobileBottomNavProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const handleMainNavigation = (event: React.SyntheticEvent, newValue: string) => {
    if (newValue === 'more') {
      setMenuAnchor(event.currentTarget as HTMLElement);
    } else {
      navigate(newValue);
    }
  };
  const menuPaths = [`/${routesProfile.TEAMS.path}`, `/${routesProfile.GROWTHTOOLS.path}`];
  const pathname = location.pathname;
  const currentValue = menuPaths.some((path) => pathname.startsWith(path))
    ? 'more'
    : pathname.startsWith(`/${routesProfile.RECOMMENDATIONS.path}`)
      ? `/${routesProfile.RECOMMENDATIONS.path}`
      : pathname.startsWith(`/${routesProfile.PROJECTS.path}`)
      ? `/${routesProfile.PROJECTS.path}`
      : pathname.startsWith(`/${routesProfile.SOCIALORDERS.path}`)
        ? `/${routesProfile.SOCIALORDERS.path}`
        : pathname.startsWith(`/${routesProfile.USERS.path}`)
          ? `/${routesProfile.USERS.path}`
          : routesProfile.ROOT.path;

  const closeMenu = () => setMenuAnchor(null);

  return (
    <>
      <BottomNavigation
        value={currentValue}
        onChange={handleMainNavigation}
        showLabels
        sx={[BottomNavStyled, isPwa && bottomNavPwaSx]}
      >
        <BottomNavigationAction
          value={routesProfile.ROOT.path}
          label="События"
          icon={<DynamicFeedRoundedIcon fontSize="medium" sx={bottomNavIconSx} />}
        />
        <BottomNavigationAction
          value={`/${routesProfile.PROJECTS.path}`}
          label="Проекты"
          icon={<IconProjects fontSize="medium" sx={bottomNavIconSx} />}
        />
        <BottomNavigationAction
          value={`/${routesProfile.SOCIALORDERS.path}`}
          label="Соц-Заказы"
          icon={<IconSocialOrders fontSize="medium" sx={bottomNavIconSx} />}
        />
        <BottomNavigationAction
          value={`/${routesProfile.USERS.path}`}
          label="Люди"
          icon={<IconUsers fontSize="medium" sx={bottomNavIconSx} />}
        />
        <BottomNavigationAction
          value="more"
          icon={<AppsRoundedIcon fontSize="medium" sx={bottomNavIconSx} />}
          label="Ещё"
        />
      </BottomNavigation>

      <BottomNavMenu 
        anchorEl={menuAnchor} 
        onClose={closeMenu} 
      />
    </>
  );
};
